// 前端直传 efficacy 存储平台 (美服 Cloudflare R2) 封装, 2026-08-16 替代后端 MinIO 中转.
// 流程: @makeblock/upload SDK 用登录态 utoken 换临时凭证 → 浏览器直传 R2 →
// 拿到 CDN 永久地址 (https://static-res.atomm.com/...), 再由调用方注册进后端 attachment 表.
//
// 注意:
// - VITE_UPLOAD_BASE_URL 必须与 VITE_PASSPORT_ENV 同环境, utoken 跨环境无效 (报 20101);
// - 本地 BYPASS 模式的占位 token 无法直传, 联调上传需关 VITE_BYPASS_AUTH 走 dev 飞书真登录;
// - 存储配置开着"覆盖上传", 路径唯一性由 buildToPath 的 uuid 保证, 不要用原始文件名当 toPath.

import { Uploader } from '@makeblock/upload';
import { auth } from './auth';

const UPLOAD_BASE_URL = import.meta.env.VITE_UPLOAD_BASE_URL || 'https://api-dev.makeblock.com';
const UPLOAD_CONFIG_NAME = import.meta.env.VITE_UPLOAD_CONFIG_NAME || 'xtool-material-platform';

const uploader = new Uploader(UPLOAD_BASE_URL);

// buildToPath 生成 <module>/yyyy/mm/dd/<uuid>.<ext>, 与后端 oss.ResolveKey 同一套路径规范.
// 实际对象 key 前面还有配置前缀 prod/xtool/material-platform/ (efficacy 配置下发, 前端不感知).
export function buildToPath(fileName: string, module = 'gallery'): string {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    const dot = fileName.lastIndexOf('.');
    const ext = dot >= 0 ? fileName.slice(dot).toLowerCase() : '';
    const id = crypto.randomUUID().replace(/-/g, '');
    return `${module}/${now.getFullYear()}/${pad(now.getMonth() + 1)}/${pad(now.getDate())}/${id}${ext}`;
}

/** sha256Hex 计算文件内容 sha256 (hex 小写), 供后端按内容去重. */
export async function sha256Hex(file: File): Promise<string> {
    const buf = await file.arrayBuffer();
    const digest = await crypto.subtle.digest('SHA-256', buf);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

/** uploadToStorage 直传单个文件到 R2, 成功返回 CDN 永久地址. */
export function uploadToStorage(file: File, toPath: string, onProgress?: (percent: number) => void): Promise<string> {
    return new Promise((resolve, reject) => {
        uploader
            .upload(auth.getUToken(), UPLOAD_CONFIG_NAME, file, toPath, {
                callback: {
                    onProgress,
                    onError: reject,
                    onSuccess: (url: string) => resolve(url),
                },
            })
            .catch(reject);
    });
}
